import { useEffect, useMemo, useRef } from 'react';
import debounce from 'lodash/debounce';

// great article highlighting the problem in terms of react
// https://www.developerway.com/posts/debouncing-in-react

const useDebounce = (callback: () => void, delay = 1000) => {
  const ref = useRef<any>(null);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, delay);
  }, []);

  return debouncedCallback;
};

export default useDebounce;
